// extracted by mini-css-extract-plugin
module.exports = {"container":"e_7z","msrp":"e_8z","save":"e_9z","discount":"e_-z","price":"e_aA"};